import EvalApi from '../api-js/eval.api';

export default class EvalService {

    static getQuestionnaire({ guid, siteId }) {
        return new Promise((resolve, reject) => {
            EvalApi.getQuestionnaire({ guid, siteId }).then((response) => {
                return response.json();
            }).then((data) => {
                resolve(data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    static submitQuestionnaire({ guid, data }) {
        return new Promise((resolve) => {
            EvalApi.submitQuestionnaire({ guid, data }).then((response) => {
                resolve(response);
            })
        });
    }
}